
import React from 'react';
import { Tooltip } from "design-react-kit";

const CustomTooltip = ({ targetId, message, isOpen, toggle, placement = "right" }) => {
    return (
        <Tooltip
            placement={placement}
            target={targetId}
            isOpen={isOpen}
            toggle={toggle}
        >
            {message}
        </Tooltip>
    );
};

export default CustomTooltip;

